/**Valor de estado Baja*/
export const deactivatedStatusesGps = ['5dbae9340b756b006a420d48','5e2a0417b020b301a9f5b584']

export const assignedStatusesGps = ['5dadb7382e51ec00c7dafdf3','5e2a0417b020b301a9f5b581'];

export const installationStatusesGps = ['5dadb66f2e51ec00c7dafdf2','5e2a0417b020b301a9f5b583'];

export const installationAndAssignedStatusesGps = [...assignedStatusesGps, ...installationStatusesGps];

export const storeStatusesGps = ["5da9c4b44d4e41001bdd42ba","5e2a0417b020b301a9f5b582"];

export const installationAndAssignedStatusesSimcard = ['5db99d25d68d8c015d684b1c','5db9eb4c6bfbc7002c2185fc',
'5e2a03f50a1697019140746e','5e2a03f50a1697019140746c'];

export const installationAndAssignedStatusesDevices = ['5db9eb586bfbc7002c2185fd','5db99daad68d8c015d684b1d',
'5e2a0406d305ba019d3c0da3','5e2a0406d305ba019d3c0da1'];